import React, { Component } from 'react'
import styled from 'styled-components'
import _ from 'lodash'

const Wrapper = styled.div`
  width: 90%;
  height: 200px;
  padding-bottom: 15px;
  overflow-x: hidden;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: rgb(233, 233, 233);
  ${'' /* flex-wrap: wrap; */} position: relative;
`

// const Skill = styled.div`
//   padding: 0px 10px;
//   font-weight: bold;
//   position: relative;
//   font-size: 13px;
//   margin: 5px 5px 0 15px;
//   ${'' /* background-color: rgb(233, 233, 233); */} border-radius: 7px;
//   color: rgb(117, 114, 114);
//   cursor: pointer;
//   transition: text-decoration 0.3 ease;
//   &:hover {
//     text-decoration: underline;
//   }
//   &::after {
//     position: absolute;
//     left: -5px;
//     content: '•';
//     top: 0;
//     bottom: 0;
//     margin: auto 0;
//   }
// `


const Skill = styled.div`
  padding: 0px 10px 0 0;
  font-weight: bold;
  position: relative;
  font-size: 13px;
  margin: 5px 5px 0 15px;
  border-radius: 7px;
  width: 90%;
  color: rgb(154, 154, 154);
  cursor: pointer;
  transition: text-decoration 0.3 ease;
`

const Key = styled.div`
  padding: 0px 10px;
  font-weight: bold;
  text-decoration: underline;
  font-size: 15px;
  margin: 10px 5px 0 0;
  ${'' /* background-color: rgb(233, 233, 233); */} border-radius: 7px;
  color: rgb(117, 114, 114);
  cursor: pointer;
`

class Skills extends Component {
  constructor(props) {
    super(props)
  }

  // setSkills = () => {
  //   let categories = { ...this.props.categories }
  //   let arrSkills = []
  //   for (var key in categories) {
  //     if (categories.hasOwnProperty(key)) {
  //       categories[key].split(';').forEach(item => {
  //         arrSkills.push(item)
  //       })
  //     }
  //   }
  //   return arrSkills
  // }

  render() {
    return (
      <div>
        <Wrapper>
          {_.map(this.props.categories, (item, key) => (
            <div key={key}>
              <Key onClick={() => this.props.handleSkillClick(key)}>{key}</Key>
              {
                item === "" ? '' :
                <Skill>
                  {
                    item.split(";").join(', ')
                  }
                </Skill>
              }

            </div>
          ))}
        </Wrapper>
      </div>
    )
  }
}

export default Skills



// WEBPACK FOOTER //
// ./src/components/search/skills.js